module.exports = __webpack_public_path__ + "static/img/img02.142d3fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/116/img02.png
// module id = Kfoq
// module chunks = 0